import type { SVGProps } from 'react';
const SvgUnarchive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#unarchive_svg__a)">
      <path
        fill="currentColor"
        d="m20.55 5.22-1.39-1.68A1.51 1.51 0 0 0 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28ZM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5ZM5.12 5l.82-1h12l.93 1H5.12Z"
      />
    </g>
    <defs>
      <clipPath id="unarchive_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgUnarchive;
